export default __webpack_public_path__ + "static/carbonfyi-2920c325c8411bd00784149fffeb1d6d.jpg";